import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import usePackageInventorySearchParams from '../../../hooks/usePackageInventorySearchParams';
import * as PackageInventoryStore from '../../../redux/packageInventory';
import FilterCard from '../../generic/Filter/FilterCard';
import useFetchPackages from '../hooks/useFetchPackages';
import type { WithResetSelectedPackage } from '../PackageInventoryContainer';

import VulnCVE from './VulnCVE';
import VulnCWE from './VulnCWE';
import VulnHasFix from './VulnHasFix';
import VulnSeverity from './VulnSeverity';

type Props = {
  withResetSelectedPackage: WithResetSelectedPackage;
};

/**
 * PackageInventoryFiltersVuln has filters related to
 * searching packages by vuln CVE, CWE, severity, and fixability.
 */
const PackageInventoryFiltersVuln: VoidFunctionComponent<Props> = ({ withResetSelectedPackage }) => {
  const setFilters = useFetchPackages(PackageInventoryStore.actions.setFilters);
  const cve = useSelector(PackageInventoryStore.selectors.getFiltersVulnCVE);
  const { filters } = usePackageInventorySearchParams();
  const cwes = filters.cwes ?? [];
  return (
    <FilterCard id="package-inventory-vuln-filters" title="Vulnerabilities">
      <VulnCVE cve={cve} setFilters={withResetSelectedPackage(setFilters)} />
      <VulnCWE cwes={cwes} setFilters={withResetSelectedPackage(setFilters)} />
      <VulnSeverity setFilters={withResetSelectedPackage(setFilters)} />
      <VulnHasFix setFilters={withResetSelectedPackage(setFilters)} />
    </FilterCard>
  );
};

export default PackageInventoryFiltersVuln;
